"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  Component,
  PropSync,
  Vue
} from "vue-property-decorator";
import { LocalStorage } from "@/framework/localstorage";
export class Controller {
  constructor() {
    this.collapse = false;
  }
}
let UiMenuBar = class extends Vue {
  constructor() {
    super(...arguments);
    this.localStorage = new LocalStorage("ui-menu-bar");
  }
  get $controller() {
    return this._controller;
  }
  created() {
    if (this.localStorage.has("collapse")) {
      const _collapse = this.localStorage.get("collapse");
      this.$controller.collapse = _collapse;
    }
  }
  collapse() {
    this.$controller.collapse = !this.$controller.collapse;
    this.localStorage.set("collapse", this.$controller.collapse);
    this.$emit("collapse", this.$controller.collapse);
  }
};
__decorateClass([
  PropSync("controller", {
    default: () => {
      return new Controller();
    }
  })
], UiMenuBar.prototype, "_controller", 2);
UiMenuBar = __decorateClass([
  Component({})
], UiMenuBar);
export {
  UiMenuBar as default
};
